/* DN5 home adapter only. DN3 r6 still owns playback, controls and Quick Shop. */
(function () {
  'use strict';

  function playable(item) {
    if (!item || !item.url) return false;
    try {
      var url = new URL(item.url, window.location.origin);
      if (!/^https?:$/.test(url.protocol)) return false;
      return item.type === 'photo' ||
        (item.type === 'video' && /\.(mp4|webm|ogg)$/i.test(url.pathname));
    } catch (error) {
      return false;
    }
  }

  function init() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-dn5-ugc-item]'));
    var entries = [];
    blocks.forEach(function (block) {
      var payload;
      try {
        payload = JSON.parse(block.querySelector('[data-dn5-ugc-payload]').getAttribute('data-dn5-ugc-payload'));
      } catch (error) {
        return;
      }
      var card = block.querySelector('[data-dn5-ugc-card]');
      if (!card || !playable(payload.media)) {
        var badge = block.querySelector('.dn5h-ugc__watch');
        if (badge) badge.textContent = 'OPEN LINK';
        return;
      }
      card.setAttribute('data-ugc-open', '');
      entries.push({
        block: block,
        media: payload.media,
        product: payload.product || {},
        handle: block.dataset.productHandle || ''
      });
    });

    entries.forEach(function (entry) {
      // r6 keeps one product while changing slides and defaults missing names
      // and ratings. Group by product and claim presence to keep both truthful.
      var key = [entry.handle, !!entry.media.name, !!entry.media.ratingConfirmed].join('|');
      var group = entries.filter(function (other) {
        return [other.handle, !!other.media.name, !!other.media.ratingConfirmed].join('|') === key;
      });
      var at = group.indexOf(entry);
      entry.block._ugcMedia = group.slice(at).concat(group.slice(0, at)).map(function (item) {
        return item.media;
      });
      entry.block._ugcProduct = entry.product;
    });
  }

  // Capture before r6's capture listener; applies to home and existing PDP.
  window.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-ugc-open]');
    var block = trigger && trigger.closest('[data-ugc-block]');
    var root = document.getElementById('dn3-reels');
    if (!block || !root || !block._ugcMedia || !block._ugcMedia.length) return;
    var product = block._ugcProduct || {};
    var home = block.hasAttribute('data-dn5-ugc-item');
    root.classList.toggle('dn5-ugc--home-anonymous', home && !block._ugcMedia.every(function (item) {
      return !!item.name;
    }));
    root.classList.toggle('dn5-ugc--rated', block._ugcMedia.every(function (item) {
      return item.ratingConfirmed === true && item.rating >= 1 && item.rating <= 5;
    }));
    root.classList.toggle('dn5-ugc--no-product', !(block.dataset.productHandle && product.title));
    var mobileTitle = root.querySelector('[data-dn5-mobile-title]');
    if (mobileTitle) mobileTitle.textContent = product.title || '';
    var mobileThumb = root.querySelector('[data-dn5-mobile-thumb]');
    if (mobileThumb) {
      if (product.images && product.images[0]) mobileThumb.src = product.images[0];
      else mobileThumb.removeAttribute('src');
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
